import type React from "react";
import { useEffect, useState } from "react";

import { getStorageValue, removeStorageValue, setStorageValue } from "utils/storage";

import { AppConfigContext } from "./AppConfigContext";

interface AppConfigContextProviderProps {
  children: React.ReactNode;
}

export const AppConfigContextProvider: React.FC<AppConfigContextProviderProps> = ({ children }) => {
  const [navBarCollapsed, setNavBarCollapsed] = useState<boolean>(!!getStorageValue("collapsedSidebar") || false);

  useEffect(() => {
    if (navBarCollapsed) {
      setStorageValue("collapsedSidebar", "collapsed");
    } else {
      removeStorageValue("collapsedSidebar");
    }
  }, [navBarCollapsed]);

  const value = {
    navBarCollapsed,
    setNavBarCollapsed,
  };

  return <AppConfigContext.Provider value={value}>{children}</AppConfigContext.Provider>;
};
